module.exports = __webpack_public_path__ + "img/antes_despues_36.d4dd8e19.png";